import Filter from '@scripts/modules/Filter.js';

class CatalogFilter extends Filter {

  constructor() {
    super();

    this.form = document.getElementById("catalog-filter-form");
    // элемент формы, отвечающий за сортировку
    this.sortBy = document.getElementById("sortby");

    this.sortItems = document.querySelectorAll("[data-sort]")
    // console.log(this.sortItems);
    this.init()
  }

  static existsOnPage() {
    return (document.getElementById("catalog-filter-form") !== null);
  }

  init() {
    this.form.addEventListener('submit', (e) => {
      // e.preventDefault()
      this.prepareForm()
      // debugger
    })

    this.sortItems.forEach((sortItem) => {
      const sortValue = sortItem.dataset.sort;

      sortItem.addEventListener('click', (e) => {
        e.preventDefault();
        this.sortBy.value = sortValue;
        this.prepareForm();
        this.form.submit();
      })

    })
  }

  /** 
   * Подготовка полей формы к отправке.
   */
  prepareForm() {
    const fieldNames = ['price', 'intensity', 'place', 'dtype']
    super.prepareForm(fieldNames);
  }
}

export default CatalogFilter;

